const esc = (s) => s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

export const fieldKind = (f) => {
    if (f === "DATA") return "date";
    if (/PORZĄDEK|ZAKRES|OPIS/.test(f)) return "textarea";
    return "text";
};

export const FIELD_HINTS = {
    GODZINA: "np. 10:00–14:00",
    KLATKA: "np. 25C lub 25 C/D/E/F",
    MIEJSCE: "np. sala w budynku 25D",
    FIRMA: "np. Gaz-Serwis Sp. z o.o.",
};

export const formatDatePl = (iso) => {
    if (!iso) return "";
    const [y, m, d] = iso.split("-");
    return `${d}.${m}.${y}`;
};

const toValue = (field, raw) => {
    if (!raw) return "";
    if (fieldKind(field) === "date") return formatDatePl(raw);
    return esc(raw).replace(/\n/g, "<br/>");
};

export const fillTemplate = (tpl, values) => {
    let subject = tpl.subject;
    let html = tpl.html;
    for (const f of tpl.fields || []) {
        const v = toValue(f, values[f]);
        if (!v) continue;
        subject = subject.split(`[${f}]`).join(fieldKind(f) === "date" ? v : values[f]);
        html = html.split(`[${f}]`).join(v);
    }
    return { subject, html };
};

export const warsawTime = (iso) =>
    iso ? new Date(iso).toLocaleString("pl-PL", { timeZone: "Europe/Warsaw", dateStyle: "medium", timeStyle: "short" }) : "";

const WARSAW_FMT = new Intl.DateTimeFormat("sv-SE", { timeZone: "Europe/Warsaw", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23" });

// "YYYY-MM-DDTHH:MM" wall-clock time in Europe/Warsaw (matches backend's scheduled_local).
export const warsawLocal = (date = new Date()) => WARSAW_FMT.format(date).replace(" ", "T");
